import { defineLanguage } from "../registry";

export default defineLanguage({
  id: "typescript",
  extensions: [".ts", ".mts", ".cts", ".d.ts"],
  runner: "javascript",
});
